import React from "react";
import {HeroType, HeroTypeButtonWrapper, HeroTypeTextWrapper, HeroTypeWrapper} from "./HeroType.styles";
import {getResponsiveImage} from "Helpers/ImageHelper";
import LazyBackgroundImage from "../../framework/lazy/LazyBackgroundImage";
import {Header} from "../HeroText";
import {ButtonText, ColoredButton} from "BaseComponents/Button";
import {getButtonColor} from "Helpers/ColorHelper";
import {RTEWrapper} from "BaseComponents/Wrappers";

export const HeroType1Block = ({
                                 Alias,
                                 ResponsiveImage,
                                 Title,
                                 Description,
                                 PrimaryButton: PButton,
                                 PrimaryButtonColor,
                                 SecondaryButton,
                                 SecondaryButtonColor,
                                 ImageFromRight,
                                 HorizontalPosition,
                                 breadcrumbLength
                               }) => {
  let Image = getResponsiveImage(ResponsiveImage);
  const alt = ResponsiveImage.Alt;

  let {color, textColor} = getButtonColor(PrimaryButtonColor);
  let {color: secondColor, textColor: secondTextColor} = getButtonColor(SecondaryButtonColor);

  let flexPosition = HorizontalPosition ? HorizontalPosition === 'center' ? 'center'
      : HorizontalPosition === 'left' ? 'flex-start'
        : HorizontalPosition === 'right' ? 'flex-end'
          : ''
    : '';

  let style = {};

  if (HorizontalPosition) {
    style = {textAlign: HorizontalPosition};
  }

  return <HeroType className={`lg:px-12 ${Alias}`}>
    <div className={"container mx-auto"}>
      <HeroTypeWrapper imageFromRight={ImageFromRight} useMargin={breadcrumbLength === 0}>
        {!!Image.length && <LazyBackgroundImage
          source={Image}
          height="100%"
          flex={1}
          smallBorderRadius={"0px"}
          alt={alt}
        />}
        <HeroTypeTextWrapper horizontalPosition={flexPosition}>
          <div style={style}>
            {!!Title.length && <Header forceLargeFontSize={"60px"}>{Title}</Header>}
            {!!Description.length && <RTEWrapper pFontSize={"18px"} dangerouslySetInnerHTML={{
              __html: Description,
            }}></RTEWrapper>}
          </div>
          <HeroTypeButtonWrapper>
            {!!PButton &&
              <ColoredButton
                inverted
                href={PButton.Url}
                minWidth="164px"
                width="fit-content"
                target={PButton.Target}
                aria-label={PButton.Name}
                padding="9.5px 40px"
                smallpadding="9.5px 40px"
                color={textColor}
                bgColor={color}
                smallmargin={"0"}
              >
                <ButtonText color={textColor} className={"customColor"}
                            heading={PButton.Name}>{PButton.Name}</ButtonText>
              </ColoredButton>}
            {!!SecondaryButton &&
              <ColoredButton
                inverted
                href={SecondaryButton.Url}
                minWidth="164px"
                width="fit-content"
                target={SecondaryButton.Target}
                aria-label={SecondaryButton.Name}
                padding="9.5px 40px"
                smallpadding="9.5px 40px"
                color={secondTextColor}
                bgColor={secondColor}
                smallmargin={"0"}
              >
                <ButtonText color={secondTextColor} className={"customColor"}
                            heading={SecondaryButton.Name}>{SecondaryButton.Name}</ButtonText>
              </ColoredButton>}
          </HeroTypeButtonWrapper>
        </HeroTypeTextWrapper>
      </HeroTypeWrapper></div>
  </HeroType>
}